import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || dsn.includes("placeholder")) {
    // eslint-disable-next-line no-console
    console.warn("Sentry deshabilitado: VITE_SENTRY_DSN no configurado.");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_APP_ENV ?? "development",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: import.meta.env.VITE_APP_ENV === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function setSentryUserContext(user: {
  id: string;
  email?: string;
  rol?: string;
  tienda_id?: string;
} | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    rol: user.rol,
    tienda_id: user.tienda_id,
  });
}

export { Sentry };
